module.exports = __webpack_public_path__ + "img/sven.816e05bf.png";